import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

const GridData = ({
  data,
  title,
}: {
  data: { label: string; value: any; endAdornment?: string }[]
  title: string
}) => {
  return (
    <Box>
      <Typography
        fontSize="1rem"
        fontWeight="500"
        sx={{
          marginBottom: '4px',
        }}
      >
        {title}
      </Typography>

      {data.map((item, i) => {
        return (
          <Box
            key={i}
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Grid container>
              <Grid item sm={6}>
                <Box
                  sx={{
                    display: 'flex',
                    gap: '10px',
                    color: '#969696',
                    fontSize: '0.9rem',
                  }}
                >
                  <Typography fontWeight="500">{item.label}</Typography>
                </Box>
              </Grid>
              <Grid item sm={6}>
                <Typography>
                  {item.value || '-'}
                  {item.endAdornment}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )
      })}
    </Box>
  )
}

export default GridData
